import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { RECEIVER_FIELDS } from '../../../../helpers/typePartner'

const PHONE_INPUT_RE = /^[0-9+\-.()\s]*$/

// Khối "Thông tin nhận hàng" dùng chung cho form Tạo / Chỉnh sửa đối tác loại May
function ReceiverFields(props) {
    const { values, onChange } = props
    const [nameField, phoneField, addressField] = RECEIVER_FIELDS

    const renderInput = (field, extraOnChange) => (
        <Input
            value={values[field.key]}
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            allowClear
            onChange={e => {
                const v = e.target.value
                if (!extraOnChange || extraOnChange(v)) onChange(field.key, v)
            }}
        />
    )

    return (
        <div className="ReceiverFields mb-3">
            <label className='font-weight-bold mb-0'>Thông tin nhận hàng (in trên phiếu xuất kho giao may)</label>
            <div className='font-italic text-muted small mb-2'>Không bắt buộc. Thay đổi chỉ áp dụng cho các lần giao may sau.</div>
            <div className="row">
                <div className="col-6 mb-3">
                    <label className='font-weight-bold'>{nameField.label}</label>
                    {renderInput(nameField)}
                </div>
                <div className="col-6 mb-3">
                    <label className='font-weight-bold'>{phoneField.label}</label>
                    {renderInput(phoneField, v => PHONE_INPUT_RE.test(v))}
                </div>
                <div className="col-12">
                    <label className='font-weight-bold'>{addressField.label}</label>
                    {renderInput(addressField)}
                </div>
            </div>
        </div>
    )
}

ReceiverFields.propTypes = {
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default ReceiverFields
